var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ResetPage',{attrs:{"context":_vm.context}})
}
var staticRenderFns = []

export { render, staticRenderFns }